module.exports = __webpack_public_path__ + "img/9788954641227.a5d61035.jpg";